import {
  DetailsSection,
  KeyDetailsBoldText,
  KeyDetailsList,
  KeyDetailsListItem,
  KeyDetailsListItemSubText,
  SectionTitle,
  KeyDetailsWithSubText,
  SubTextSmall,
} from "pages/Application/Recommendation/Recommendation.styles"
import { ToCurrency } from "lib/CurrencyFormatter"
import React from "react"

interface AboutYourMortgageProps {
  propertyValue: any
  purchasePrice: any
  currentMortgageBalance: any
  additionalBorrowingAmount: any
  totalLoanAmount: any
  borrowingAmountFormatted: any
  addArrangementFeeToLoan: boolean
  formattedArrangementFee: string
  ltv: any
  termYears: any
  years: number
  months: number
}

export const AboutYourMortgageSection = ({
  propertyValue,
  purchasePrice,
  currentMortgageBalance,
  additionalBorrowingAmount,
  totalLoanAmount,
  borrowingAmountFormatted,
  addArrangementFeeToLoan,
  formattedArrangementFee,
  ltv,
  termYears,
  years,
  months,
}: AboutYourMortgageProps): JSX.Element => {
  return (
    <KeyDetailsList aria-label="Your mortgage">
      {!!propertyValue && (
        <KeyDetailsListItem>
          <KeyDetailsBoldText>Property value</KeyDetailsBoldText>
          <KeyDetailsBoldText>{ToCurrency(propertyValue)}</KeyDetailsBoldText>
        </KeyDetailsListItem>
      )}
      {!!purchasePrice && (
        <KeyDetailsListItem>
          <KeyDetailsBoldText>Purchase price</KeyDetailsBoldText>
          <KeyDetailsBoldText>{ToCurrency(purchasePrice)}</KeyDetailsBoldText>
        </KeyDetailsListItem>
      )}
      {!!currentMortgageBalance && (
        <KeyDetailsListItem>
          <KeyDetailsBoldText>Balance</KeyDetailsBoldText>
          <KeyDetailsBoldText>{ToCurrency(currentMortgageBalance)}</KeyDetailsBoldText>
        </KeyDetailsListItem>
      )}
      {!!additionalBorrowingAmount && !purchasePrice && (
        <KeyDetailsListItem>
          <KeyDetailsBoldText>Additional borrowing</KeyDetailsBoldText>
          <KeyDetailsBoldText>{ToCurrency(additionalBorrowingAmount)}</KeyDetailsBoldText>
        </KeyDetailsListItem>
      )}
      {!!totalLoanAmount && (
        <KeyDetailsListItem>
          <KeyDetailsWithSubText>
            <div>
              <KeyDetailsBoldText>Borrowing total</KeyDetailsBoldText>
              <KeyDetailsBoldText>{borrowingAmountFormatted}</KeyDetailsBoldText>
            </div>
            <div>
              <SubTextSmall>{/* Empty to force sibling in right col */}</SubTextSmall>
              {addArrangementFeeToLoan && (
                <SubTextSmall>
                  <KeyDetailsListItemSubText>
                    Includes £{formattedArrangementFee} arrangement fee
                  </KeyDetailsListItemSubText>
                </SubTextSmall>
              )}
            </div>
          </KeyDetailsWithSubText>
        </KeyDetailsListItem>
      )}
      {!!ltv && typeof ltv === "number" && (
        <KeyDetailsListItem>
          <KeyDetailsBoldText>Loan to value</KeyDetailsBoldText>
          <KeyDetailsBoldText>{Math.floor(ltv)}%</KeyDetailsBoldText>
        </KeyDetailsListItem>
      )}
      {!!termYears && (
        <KeyDetailsListItem>
          <KeyDetailsBoldText>Term</KeyDetailsBoldText>
          <KeyDetailsBoldText>
            {years ? <span>{years} years</span> : null}
            {months ? <span> {months} months</span> : null}
          </KeyDetailsBoldText>
        </KeyDetailsListItem>
      )}
    </KeyDetailsList>
  )
}
